import EditIcon from "@mui/icons-material/Edit";
import { Box, Dialog, IconButton, Tooltip } from "@mui/material";
import { useDialog } from "common";
import EventGroupForm from "features/event-groups/EventGroupForm";
import I18n from "i18n";
import EventForm from "../EventForm";
import { useEventEditorContext } from "./EventEditorContext";

export default function EditEventsButton() {
  const {
    selectedEvents,
    selectedEventGroups,
    cal,
    groupActionsEnabled,
    groupEditMode,
  } = useEventEditorContext();

  // Separate dialogs for event and group edit
  const [isEventOpen, setIsEventOpen, eventDialogProps] = useDialog();
  const [isGroupOpen, setIsGroupOpen, groupDialogProps] = useDialog();

  const handleClick = () => {
    if (groupEditMode === "event") setIsEventOpen(true);
    else if (groupEditMode === "group") setIsGroupOpen(true);
  };

  return (
    <>
      <Tooltip
        title={
          groupEditMode === "event"
            ? I18n.t("EventEditor.groupEditEvents.modify")
            : I18n.t("EventEditor.groupEdit.groups")
        }
      >
        <Box>
          <IconButton
            color="info"
            onClick={handleClick}
            disabled={!groupActionsEnabled}
          >
            <EditIcon />
          </IconButton>
        </Box>
      </Tooltip>
      <Dialog {...eventDialogProps} maxWidth="xl" fullWidth>
        <EventForm
          eventIds={selectedEvents}
          id={selectedEvents[0] as any}
          onClose={eventDialogProps.onClose}
          afterSave={() => {
            cal?.current?.refresh();
            eventDialogProps.onClose &&
              eventDialogProps.onClose({}, "backdropClick");
          }}
          hideBookingList
        />
      </Dialog>
      <Dialog {...groupDialogProps} maxWidth="sm" fullWidth>
        <EventGroupForm
          id={selectedEventGroups[0] as any}
          eventGroupIds={selectedEventGroups}
          onClose={groupDialogProps.onClose}
          afterSave={() => {
            cal?.current?.refresh();
            groupDialogProps.onClose &&
              groupDialogProps.onClose({}, "backdropClick");
          }}
        />
      </Dialog>
    </>
  );
}
